import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient } from '../models';
import { Api, Session } from '../services/index';
import { MyModal } from '../components/modal/modal';

@Component({
  selector: 'app-bh-pricing',
  templateUrl: './bh-pricing.html'
})



export class BHPricing  {
  patientId: number;
  ucCopay:number = -1;//uc 	urgent care
	bhCopay:number = -1;//bh 	behavioral health
	psiCopay:number = -1;//psi  psych initial
	psfCopay:number = -1;//psf	psych follow up
	loading:boolean = false;

  constructor(private router: Router,
    private api: Api, private route: ActivatedRoute) {
      this.patientId = this.route.snapshot.params['patientId'] || '';
    this.initializePricing();
    }

  // continue(){
  //   this.router.navigateByUrl('/dashboard-medical/2');
	// }
	requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
	}

	gotoDashboard() {
		this.router.navigate(['/dashboard-medical/2']);
	}

  //todo create a pricing service.
  //
  initializePricing(){
		this.loading = true;
		let lob =  'bh';

		this.ucCopay = -1;
		this.bhCopay = -1;
		this.psiCopay = -1;
		this.psfCopay = -1;

		this.api.getPatientPlans(this.patientId, lob ).subscribe(result =>{
			console.log('getPatientPlans',result);
			if(result == null || result.length === 0  ){
				console.log('defaulting pay rates.');
				this.ucCopay = 57.95;
				this.bhCopay = 0;
				this.psiCopay = 200;
				this.psfCopay = 95;
        this.loading = false;
				return;
			}

			result.forEach(policy => {
				if(policy == null){
					console.log('policy is null:', policy);
          this.loading = false;
					return;
				}

				console.log('policy.PlanTypeCode:', policy.planTypeCode);
				switch(policy.planTypeCode){
					case 'UC':
						if(this.ucCopay > policy.coPay || this.ucCopay < 0 ){
							this.ucCopay = policy.coPay;
						}
					break;
					case 'BH':
						if(this.bhCopay > policy.coPay || this.bhCopay < 0 ){
							this.bhCopay = policy.coPay;
						}
					break;
					case 'PSI':
						if(this.psiCopay > policy.coPay || this.psiCopay < 0){
							this.psiCopay = policy.coPay;
						}
					break;
					case 'PSF':
						if(this.psfCopay > policy.coPay || this.psfCopay < 0 ){
							this.psfCopay = policy.coPay;
						}
					break;
				}

			});

			if(this.ucCopay < 0 ){ this.ucCopay = 57.95; }
			if(this.bhCopay < 0){ this.bhCopay = 80; }
			if(this.psiCopay< 0){ this.psiCopay = 200; }
			if(this.psfCopay< 0){ this.psfCopay = 95; }
			this.loading = false;
		});
	}
}
